module.exports = __webpack_public_path__ + "img/banner.a28e1688.png";